export function PercentValue(props) {
    const { value } = props;

    return (
        <>
            {value}%
        </>
    );
}